import { FC } from 'react';

import { SvgIconProps } from 'types/styles';
import { SvgIcon } from 'ui/SvgIcon';

export const DocumentIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <g opacity="0.5">
      <path
        d="M19.903 9.086C19.8556 8.97747 19.7892 8.87825 19.707 8.793L13.707 2.793C13.6217 2.71078 13.5225 2.64441 13.414 2.597C13.384 2.583 13.352 2.575 13.32 2.564C13.2363 2.53553 13.1492 2.51837 13.061 2.513C13.04 2.511 13.021 2.5 13 2.5H6C4.897 2.5 4 3.397 4 4.5V20.5C4 21.603 4.897 22.5 6 22.5H18C19.103 22.5 20 21.603 20 20.5V9.5C20 9.479 19.989 9.46 19.987 9.438C19.9821 9.34972 19.9649 9.26255 19.936 9.179C19.926 9.147 19.917 9.116 19.903 9.086ZM16.586 8.5H14V5.914L16.586 8.5ZM6 20.5V4.5H12V9.5C12 9.76522 12.1054 10.0196 12.2929 10.2071C12.4804 10.3946 12.7348 10.5 13 10.5H18L18.002 20.5H6Z"
        fill="#323B55"
      />
      <path
        d="M8 12.5H16V14.5H8V12.5ZM8 16.5H16V18.5H8V16.5ZM8 8.5H10V10.5H8V8.5Z"
        fill="#323B55"
      />
    </g>
  </SvgIcon>
);
